var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 36,
    viewBox: "0 0 54 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a02dfc69be13291199b39906b2abd737",
    d: "M68.818,127a7.5,7.5,0,1,0-7.364-7.5A7.455,7.455,0,0,0,68.818,127Zm-19.636,0a7.5,7.5,0,1,0-7.364-7.5A7.455,7.455,0,0,0,49.182,127Zm0,5.5C43.413,132.5,32,135.375,32,141.25V148H66.714v-6.75C66.714,135.375,54.95,132.5,49.182,132.5Zm19.636,1.375a12.638,12.638,0,0,0-2.1.125c2.824,2.125,3.857,3.5,3.857,7.25V148H86v-6.75C86,135.375,74.587,133.875,68.818,133.875Z",
    transform: "translate(-32 -112)",
    fill: "#74613c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuests);
export default __webpack_public_path__ + "static/media/guests.da20fc889af9bdf80fac74307a53cee9.svg";
export { ForwardRef as ReactComponent };